import { render, staticRenderFns } from "./DeliveryFormView.vue?vue&type=template&id=037084fe&scoped=true&"
import script from "./DeliveryFormView.vue?vue&type=script&lang=js&"
export * from "./DeliveryFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037084fe",
  null
  
)

export default component.exports